import { render, staticRenderFns } from "./PayItemNew.vue?vue&type=template&id=10a96ed4"
import script from "./PayItemNew.vue?vue&type=script&lang=js"
export * from "./PayItemNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports